import axios from 'axios'

interface searchPsapsPayload {
    searchTerm: string
}

export interface Psap {
    id: number | false
    psapId: number
    name: string
    state: string
    county: string
    city: string
    comments: string
    dateModified: Date
    dateRecordCreated: Date
    typeOfChange: string
}
export function searchPsaps(payload: searchPsapsPayload) {
    return axios.post<Psap[]>(`/api/v1/psap/search`, payload)
}
